<div id='job-tasks-list'>
  <div class='or-content-body'>
    <div class='job-tasks-list'>
      @for (task of tasks(); track task.id; let i = $index) {
        <div>
          <app-job-tasks-summary
            [job]='job()'
            [task]='task'
            [index]='i'
            [(jobStartEnabled)]='jobStartEnabled'>
          </app-job-tasks-summary>
        </div>
      }
    </div>
  </div>
</div>
